require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tous-les-services-1-1.json") })
        }
      }, "path---tous-les-services-1-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tous-les-services-1-1!./.cache/json/tous-les-services-1-1.json
// module id = 590
// module chunks = 231608221292675